import { createSource, Recommended } from '@wix/media-manager-sdk';
import { __, contains, join, reject } from 'ramda';
import { WixMediaRoot } from '../../../constants/WixMediaRoot';
import { MainSource } from '../../../constants/Source';
import { UnsplashRecommendedMediaType } from '../../../constants/UnsplashRecommendedMediaType';
import { parseSiteMediaToken } from '../../siteMediaToken';
import { uniqueId } from '../../uniqueId';
import { MediaManagerSDKFile, MediaManagerSDKResponse } from '../index';
import { readCookie } from './utils';

const getWixMediaRoots = (publicMediaRoot) =>
  reject(contains(__, [WixMediaRoot.Illustrations, WixMediaRoot.SocialIcons]), publicMediaRoot);

export class RecommendedHomeSource {
  items: {
    list(
      _: any,
      settings: {
        recommendedCategories: string[];
        paging: { size: number; cursor?: string };
        sort: { description: string; order: string };
      },
    ): MediaManagerSDKResponse<MediaManagerSDKFile[]>;
  };

  topics: {
    list(options: any): any;
  };

  categories: {
    get(): any;
    update(categories: string[]): any;
  };

  constructor(settings) {
    const { recommendedHomeSettings, siteMediaToken, publicMediaRoot, tabsList, metaSiteToken } = settings;
    const xsrfToken = readCookie('XSRF-TOKEN');

    const wixMediaRoots = contains(MainSource.MediaFromWix, tabsList) ? getWixMediaRoots(publicMediaRoot) : null;
    const unsplashMediaTypes = contains(MainSource.Unsplash, tabsList) ? [UnsplashRecommendedMediaType.Images] : null;

    const { metaSiteId } = parseSiteMediaToken(siteMediaToken);

    const uid = uniqueId();

    const adapter = createSource(Recommended, {
      ...recommendedHomeSettings,
      xsrfToken,
      siteMediaToken,
      itemsCacheCapacity: 1,
      metaSiteToken,
    });

    this.items = {
      list: (_, { recommendedCategories, paging, sort }) => {
        const cacheId = `${join(',', recommendedCategories)}${uid}`;

        return adapter.items.list({
          paging,
          sort,
          cacheId,
          xsrfToken,
          siteMediaToken,
          wixMediaRoots,
          shutterstockMediaTypes: null,
          unsplashMediaTypes,
        });
      },
    };

    this.topics = adapter.topics;

    this.categories = {
      get: () => adapter.preferences.mediaCategories({ xsrfToken, siteMediaToken, msid: metaSiteId }),
      update: (categories) =>
        adapter.preferences.updateMediaCategories(categories, { xsrfToken, siteMediaToken, msid: metaSiteId }),
    };
  }
}
